// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 *//*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */.field>.mat-checkbox.ml-40,.field>.mat-mdc-checkbox.ml-40{margin-left:40px}:host ::ng-deep .job-redo-job-field{min-width:150px;max-width:150px}.detail-field.redo-details{display:flex}.detail-field.redo-details .detail-field__label{width:140px}.detail-field.redo-details .detail-field__value{flex:1}`, "",{"version":3,"sources":["webpack://./packages/builder-manager/job-redo/components/job-redo-estimate/job-redo-estimate.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAAA;;;EAAA,CAQA,0DAEE,gBAAA,CAGF,oCACE,eAAA,CACA,eAAA,CAGF,2BACE,YAAA,CACA,gDACE,WAAA,CAGF,gDACE,MAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n\n@use \"theme/styles/settings\" as *;\n@use \"theme/styles/tools\" as *;\n\n.field > .mat-checkbox.ml-40,\n.field > .mat-mdc-checkbox.ml-40 {\n  margin-left: 40px;\n}\n\n:host ::ng-deep .job-redo-job-field {\n  min-width: 150px;\n  max-width: 150px;\n}\n\n.detail-field.redo-details {\n  display: flex;\n  .detail-field__label {\n    width: 140px;\n  }\n\n  .detail-field__value {\n    flex: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
